import{j as e,m as s}from"./chunk-HBP5N4FR.js";s();function u(t){return e(this,null,function*(){return yield new Promise(n=>{setTimeout(()=>n(),t)})})}export{u as a};
//# sourceMappingURL=chunk-NAN2H6P3.js.map
